import draftTradesReducer from '../state/draft-trades-slice'

export const draftTradesReducers = {
  draftTrades: draftTradesReducer
}
